import { gql } from "@apollo/client";

export const GET_BOOKING_TYPE_CATEGORIES = gql`
  query GetBookingTypeCategories {
    bookingTypeCategories {
      id
      name
    }
  }
`;
